import Typography from '@mui/material/Typography';
import { FC, ReactNode } from 'react';

export const ConfirmModalBody: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Typography
      variant="body1"
      sx={(theme) => ({
        lineHeight: '2rem',
        marginBottom: theme.spacing(6),
      })}
    >
      {children}
    </Typography>
  );
};
